import { CustomValidation } from "../ISchema";
import i18n from "../../config/i18n";

type Exceeded =
  | "CURRENT_YEAR"
  | "NEXT_YEAR"
  | "WEEK"
  | "CURRENT_COURSE"
  | "NEXT_COURSE"
  | "CURRENT_YEAR_LEGAL"
  | "NEXT_YEAR_LEGAL"
  | "CURRENT_COURSE_LEGAL"
  | "NEXT_COURSE_LEGAL";
type BlocksKeys = "exceeded_blocks" | "assignable_blocks" | "blocks_to_add";

const validationNames: Record<Exceeded, string> = {
  CURRENT_YEAR: "current-year",
  NEXT_YEAR: "next-year",
  WEEK: "weekly",
  CURRENT_COURSE: "current-course",
  NEXT_COURSE: "next-course",
  CURRENT_YEAR_LEGAL: "current-year",
  NEXT_YEAR_LEGAL: "next-year",
  CURRENT_COURSE_LEGAL: "current-course",
  NEXT_COURSE_LEGAL: "next-course",
};

class SessionByCode {
  private incidence: CustomValidation;
  constructor(error: CustomValidation) {
    this.incidence = error;
  }

  private getBlockByKey = (blockKey: BlocksKeys) => {
    const item = this.incidence.items.find(error => error.key === blockKey);
    return item ? item.value : 0;
  };

  private getMessageByInstructor = (stringType: Exceeded, isGeneric = false) => {
    if (this.incidence.info.__typename === "InstructorInfo") {
      const instructorCode = this.incidence.info.instructor
        ? this.incidence.info.instructor.code
        : "";
      const exceededBlocks = this.getBlockByKey("exceeded_blocks");
      const assignableBlocks = this.getBlockByKey("assignable_blocks");
      const blocksToAdd = this.getBlockByKey("blocks_to_add");
      const validationName = i18n.t(
        `assignation-edit.incidence-table.validations.exceeded-generic-blocks.${validationNames[stringType]}`,
      );
      const validationKeyName = stringType?.split("_").includes("LEGAL")
        ? i18n.t("assignation-edit.incidence-table.validations.exceeded-generic-blocks.legal")
        : i18n.t("assignation-edit.incidence-table.validations.exceeded-generic-blocks.agreement");

      return !isGeneric
        ? i18n.t(
            stringType === "WEEK"
              ? "assignation-edit.incidence-table.validations.instructor-exceeded-weekly-blocks.description"
              : stringType === "CURRENT_YEAR"
              ? "assignation-edit.incidence-table.validations.exceeded-assignable-blocks-current-year.description"
              : "assignation-edit.incidence-table.validations.exceeded-assignable-blocks-upcoming-year.description",
            {
              instructorCode,
              assignableBlocks,
              exceededBlocks,
            },
          )
        : i18n.t(
            "assignation-edit.incidence-table.validations.exceeded-generic-blocks.description",
            {
              instructorCode,
              validationName: `${validationKeyName} ${validationName}`,
              assignableBlocks,
              exceededBlocks: blocksToAdd,
            },
          );
    }
  };

  private incidenceByDate = (type: Exceeded, isGeneric = false) => {
    if (this.incidence.info.__typename === "InstructorInfo")
      return this.getMessageByInstructor(type, isGeneric);
    return null;
  };

  private incidenceCip = () => {
    if (this.incidence.info.__typename === "InstructorInfo") {
      const code = this.incidence.info.instructor?.code;
      return code
        ? i18n.t("assignation-edit.incidence-table.validations.incicende-cip.description", {
            instructorCode: code,
          })
        : null;
    }
    return null;
  };

  public getMessage() {
    if (this.incidence && this.incidence.code) {
      switch (this.incidence.code) {
        case "ExceededLegalBlocksCurrentYear":
          return this.incidenceByDate("CURRENT_YEAR_LEGAL", true);

        case "ExceededAgreementBlocksCurrentYear":
          return this.incidenceByDate("CURRENT_YEAR", true);

        case "ExceededLegalBlocksCurrentCourse":
          return this.incidenceByDate("CURRENT_COURSE_LEGAL", true);

        case "ExceededAgreementBlocksCurrentCourse":
          return this.incidenceByDate("CURRENT_COURSE", true);

        case "ExceededLegalBlocksUpcomingYear":
          return this.incidenceByDate("NEXT_YEAR_LEGAL", true);

        case "ExceededAgreementBlocksUpcomingYear":
          return this.incidenceByDate("NEXT_YEAR", true);

        case "ExceededLegalBlocksUpcomingCourse":
          return this.incidenceByDate("NEXT_COURSE_LEGAL", true);

        case "ExceededAgreementBlocksUpcomingCourse":
          return this.incidenceByDate("NEXT_COURSE", true);

        case "ExceededAssignableBlocksCurrentYear":
          return this.incidenceByDate("CURRENT_YEAR");

        case "ExceededAssignableBlocksUpcomingYear":
          return this.incidenceByDate("NEXT_YEAR");

        case "ExceededWeeklyAssignableBlocks":
          return this.incidenceByDate("WEEK");
        case "CipCode":
          return this.incidenceCip();
        default:
          return null;
      }
    } else {
      return null;
    }
  }
}

export default SessionByCode;
